import * as tf from "@tensorflow/tfjs";
import { setWasmPaths } from "@tensorflow/tfjs-backend-wasm";

import wasmSimdPath from "../../node_modules/@tensorflow/tfjs-backend-wasm/dist/tfjs-backend-wasm-simd.wasm";
import wasmSimdThreadedPath from "../../node_modules/@tensorflow/tfjs-backend-wasm/dist/tfjs-backend-wasm-threaded-simd.wasm";
import wasmPath from "../../node_modules/@tensorflow/tfjs-backend-wasm/dist/tfjs-backend-wasm.wasm";

import { base64ToFile } from "../Utils/constants";
import { setErrorStatus } from "../Redux/status/action";
import "@tensorflow/tfjs-backend-wasm";
import Human from "@vladmandic/human";
import { useState, useRef, useEffect } from "react";
import { isValidObject } from "../Services/validators";
import { compareFace } from "../Services/api";

export function useFaceDetection() {
  const humanRef = useRef(null);
  const [humanInitialized, setHumanInitialized] = useState(false);

  async function initializeHuman() {
    if (humanRef.current) {
      return;
    }
    if (tf.getBackend() !== "wasm") {
      setWasmPaths({
        "tfjs-backend-wasm.wasm": wasmPath,
        "tfjs-backend-wasm-simd.wasm": wasmSimdPath,
        "tfjs-backend-wasm-threaded-simd.wasm": wasmSimdThreadedPath
      });

      await tf.setBackend("wasm");
      await tf.ready();
    }

    const humanConfig = {
      backend: "wasm",
      modelBasePath: `${process.env.PUBLIC_URL}/models`,
      face: { enabled: true },
      debug: false
    };

    const instance = new Human(humanConfig);
    await instance.load();

    humanRef.current = instance;
    setHumanInitialized(true);
  }

  useEffect(() => {
    initializeHuman();
  }, []);

  async function detectFace(image) {
    if (!humanRef.current || !humanInitialized || !image) return null;
    let result = await humanRef.current.detect(image);
    // if (result?.face?.length === 1) {
    //   const box = result.face[0].box;
    //   const isFullFaceVisible =
    //     box[0] > 0 &&
    //     box[1] > 0 &&
    //     box[0] + box[2] < result.width &&
    //     box[1] + box[3] < result.height;
    //   console.log("isFullFaceVisible:", isFullFaceVisible);
    //   if (!isFullFaceVisible) {
    //     result.face = [];
    //   }
    // }
    return result;
  }

  return { humanInitialized, detectFace };
}

export function convertMeshToBox(mesh) {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  for (const points of mesh) {
    if (points[0] < minX) minX = points[0];
    if (points[1] < minY) minY = points[1];
    if (points[0] > maxX) maxX = points[0];
    if (points[1] > maxY) maxY = points[1];
  }

  const width = maxX - minX;
  const height = maxY - minY;

  return [minX, minY, width, height]; // x, y, width, height
}

// export const isFaceInsideFrame = (faceBox, frameBox) => {
//   const [faceX, faceY, faceW, faceH] = faceBox;
//   const [frameX, frameY, frameW, frameH] = frameBox;

//   return (
//     faceX >= frameX &&
//     faceY >= frameY &&
//     faceX + faceW  <= frameX + frameW &&
//     faceY + faceH <= frameY + frameH
//   );
// };

export const isFaceInsideFrame = (mesh, frameBox) => {
  const startX = frameBox[0];
  const endX = frameBox[0] + frameBox[2];
  const startY = frameBox[1];
  const endY = frameBox[1] + frameBox[3];

  for (const points of mesh) {
    if (
      points[0] >= startX &&
      points[0] <= endX &&
      points[1] >= startY &&
      points[1] <= endY
    ) {
      continue;
    } else {
      return false;
    }
  }

  return true;
};

export async function compareCapturedFace({
  photo,
  location,
  profileData,
  accessToken
}) {
  try {
    if (typeof location?.locationId === "string" && location.locationId) {
      let data = new FormData();
      // FormData stringifies undefined to "undefined", so skip missing values.
      const appendIfPresent = (key, value) => {
        if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      };
      appendIfPresent("address", location.location);
      data.append("createdAt", +new Date());
      data.append("employeeId", profileData?.employeeId);
      data.append("employeeName", profileData?.name || "N/A");
      appendIfPresent("employeePhoneNumber", profileData?.phoneNumber);
      data.append("locationId", location.locationId);
      appendIfPresent("PCTNo", location.PCTNo);
      data.append("photo", base64ToFile(photo, "image.png", "image/png"));
      data.append("previewPhoto", photo);
      appendIfPresent("ward", location.ward);
      appendIfPresent("zone", location.zone);
      if (isValidObject(location?.geoContext)) {
        data.append("geoContext", JSON.stringify(location?.geoContext));
      }

      return await compareFace(data, accessToken);
    }
    setErrorStatus({ code: "custom", message: "Not in valid location" });
  } catch (error) {
    setErrorStatus(error, "compareCapturedFace");
    throw error;
  }
}
